/**
 * URL patterns for Sentry trace propagation.
 *
 * These regexes MUST NOT use the global (`g`) flag — Sentry's SDK calls
 * `.test()` repeatedly, and the `g` flag causes `lastIndex` to persist
 * between calls, making match results alternate true/false.
 */
export const TRACE_PROPAGATION_PATTERNS: RegExp[] = [
  /^https:\/\/.*\.sportable\.com.*/,
  /^http:\/\/[^/]+:8888.*/
]
